/*! Copyright 2025 Lane Crawford, All Rights Reserved. */


/**
 *
 * [ module ]
 * pdp -> delivery
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.pdp = LC.pdp || {};

	LC.pdp.delivery = lcmodule( function( exports ) {

		exports.moduleName = "pdp.delivery";

		// "exports" is always passed in, and always
		// returned at the end. Bind "ex" as it's easier to type
		// "_this" is used for private binding and maintaining scope

		var ex = exports = $.extend( {}, window.lcmoduledefaults, exports ),
			_this = {};



		/**
		 * initialise the delivery module
		 */
		ex.init = function() {

			var $promise = 			$(".delivery-promise");

			_this.$promise = 		$promise;
			_this.$content = 		$promise.find(".delivery-promise__content");
			_this.$spinner = 		$promise.find(".delivery-promise__spinner");

			_this.$delivery = 		$promise.find(".delivery-promise__delivery");
			_this.$deliveryTitle = 	$promise.find(".delivery-promise__delivery-title");
			_this.$deliveryDest = 	$promise.find(".delivery-promise__delivery-destination");
			_this.$deliveryTime = 	$promise.find(".delivery-promise__delivery-time");

			_this.$collect = 		$promise.find(".delivery-promise__collect");
			_this.$collectTitle = 	$promise.find(".delivery-promise__collect-title");
			_this.$collectDetails = $promise.find(".delivery-promise__collect-details");

			_this.fadeSpeed = 		200;
			_this.canShow = 		true;

			// get initial pdp data
			_this.bodydata = 		$("body").data();
			_this.pdpdata = 		$("#pdpdata").data();
			_this.deliverydata = 	$("#deliverydata").data();

			_this.initDisplay();

			ex.subscribe();
			ex.events();

		};

		_this.initDisplay = function() {

			var isHongKongSite = LC.helpers.isHongKongSite(),
				showPromise = _this.deliverydata.showDeliveryPromise,
				collectOnly = _this.deliverydata.isCollectOnly,
				validSku = LC.helpers.isSku( _this.pdpdata.skuId );

			_this.canShow = false;

			if ( showPromise ) {

				if ( validSku ) {

					// only show delivery if the website is HongKong,
					// or if the product is not collection only.
					if ( isHongKongSite || !collectOnly ) {

						_this.canShow = true;

					}

				}

			}

			ex.displayPromise();

		};

		ex.setWhen = function( data ) {

			var when;

			if ( typeof data.milliseconds === "undefined" ) {

				when = "???";

			} else if ( data.deliverToday === "true" ) {

				when = Lang[ "deliveryPromise.text.today" ];

			} else if ( data.deliverTomorrow === "true" ) {

				when = Lang[ "deliveryPromise.text.tomorrow" ];

			} else {

				when = LC.format.deliveryDate({

					posix: data.milliseconds,
					month: "short",
					year: false

				});

			}

			_this.$deliveryTime.text( when );

		};

		ex.setWhere = function( data ) {

			var city = data.cityDisplayName,
				state = data.stateDisplayName,
				country = data.countryDisplayName,
				district = data.districtDisplayName,
				where;

			if ( state !== "" ) {
				where = state;

			} else if ( district !== "" ) {
				where = district;

			} else if ( city !== "" ) {
				where = city;

			} else if ( country !== "" ) {
				where = country;

			}

			_this.$deliveryDest.text( where );

		};

		ex.showCollect = function( show ) {

			_this.$collect.toggleClass( ex.hiddenClass, !show );

		};

		ex.showDelivery = function( show ) {

			_this.$delivery.toggleClass( ex.hiddenClass, !show );

		};

		ex.hideContent = function() {

			_this.$content
				.addClass("opc-0");

		};

		ex.showContent = function() {

			setTimeout(function() {
				_this.$content.removeClass("opc-0");
			}, _this.fadeSpeed );

			ex.hideSpinner();

		};

		ex.displayPromise = function() {

			if ( _this.canShow ) {

				_this.$promise.removeClass( ex.hiddenClass );

			} else {

				_this.$promise.addClass( ex.hiddenClass );

			}

		};

		ex.hideSpinner = function() {

			_this.$spinner
				.removeClass("disp-n")
				.addClass("opc-0");

			setTimeout(function() {
				_this.$spinner.addClass("disp-n");
			}, _this.fadeSpeed );

		};

		ex.showSpinner = function() {

			_this.$spinner
				.addClass("opc-0")
				.removeClass("disp-n");

			setTimeout(function() {
				_this.$spinner.removeClass("opc-0");
			}, _this.fadeSpeed );

			ex.hideContent();

		};

		/**
		 * uses the ajax response from the pdp update
		 * (not the delivery promise) to determine if it should
		 * be visible or not.
		 */
		_this.setWidgetState = function( response ) {

			var isNormal = response.productStatus === "normal",
				isGiftCard = response.productStatus === "giftCard",
				hasInventory = response.inventory > 0,
				collectOnly = (
					response.availabilityWidgetInfo.isCollectAtStoreOnly === true ||
					response.availabilityWidgetInfo.isCollectAtStoreOnly === "true" ),
				isHongKongSite = LC.helpers.isHongKongSite();

			/**
			 * We can only show the delivery promise if the
			 * product has inventory, and it's a normal product.
			 *
			 * We also cannot show delivery promise to customers
			 * if the product is collectOnly and they are outside of HK.
			 */
			if ( !isHongKongSite && collectOnly ) {

				_this.canShow = false;

			} else if ( hasInventory && ( isNormal || isGiftCard ) ) {

				_this.canShow = true;

			} else {

				_this.canShow = false;

			}

			ex.displayPromise();

		};

		/**
		 * uses the ajax response from the pdp update
		 * (not the delivery promise) to determine if delivery should
		 * be visible or not.
		 */
		_this.setCollectDisplay = function( response ) {

			var hongKongSite = LC.helpers.isHongKongSite();

			/**
			 * for some reason, we only want to show the
			 * collection option in Hong Kong. And anyone in the
			 * rest of the world cannot collect, anyway.
			 */
			if ( hongKongSite ) {

				ex.showCollect( true );

			} else {

				ex.showCollect( false );

			}

			/**
			 * set the title of collect at store, if possible.
			 */
			if ( response.availabilityWidgetInfo.collectAtStoreTitle ) {

				_this.$collectTitle.text( response.availabilityWidgetInfo.collectAtStoreTitle );

			}

		};

		/**
		 * uses the ajax response from the pdp update
		 * (not the delivery promise) to determine if collection should
		 * be visible or not.
		 */
		_this.setDeliveryDisplay = function( response ) {

			var collectOnly = (
           		response.availabilityWidgetInfo.isCollectAtStoreOnly === true ||
           		response.availabilityWidgetInfo.isCollectAtStoreOnly === "true" );

			if ( collectOnly ) {

				ex.showDelivery( false );

			} else {

				ex.showDelivery( true );

			}

		};

		/**
		 * take the essential info from the API, and then
		 * update the UI with each part needed.
		 */
		_this.rebuild = function( response ) {

			if ( typeof response !== "undefined" ) {

				if ( _this.canShow ) {

					ex.displayPromise();

					ex.setWhere( response );
					ex.setWhen( response );

					ex.showContent();

				}

			} else {

				_this.canShow = false;
				ex.displayPromise();

			}

		};

		/**
		 * refresh the UI
		 */
		ex.refresh = function( data ) {

			var response = data.response;
			_this.rebuild( response.atgResponse[ 0 ] );

		};

		/**
		 * use the delivery promise module to get the
		 * delivery date, we are also listening for the promise
		 * module to trigger an update in the subscriptions method.
		 *
		 * @param  { String } skuid 	| the id of the product we want to check delivery on
		 * @param  { String } orderid 	| the id of the order we want to check delivery on
		 *
		 */
		ex.getPromise = function( skuid, orderid ) {

			var sku = skuid,
				orderId = orderid || _this.pdpdata.orderId;

			ex.showSpinner();

			// if an sku is supplied, then we try to get the
			// delivery promise from server...
			if ( skuid ) {

				LC.pubsub.trigger("deliveryPromise.get", {

					sku: sku,
					orderId: orderId

				});

			// if there's no SKU, we need to just
			// hide the delivery promise.
			} else {

				// simulate an ajax call, makes things look
				// a little nicer.
				setTimeout( function() {
					_this.rebuild( undefined );
				}, 200 );

			}

		};

		/**
		 * Method to open the delivery date modal.
		 */
		ex.openDeliveryModal = function() {

			var url = "/dialog/_revamp/global/delivery-date.jsp?showProduct=true",

				$checkedSize = $(".product-sizes__select option:selected"),
				sku = $checkedSize.data("skuid");

			// check if the sku is actually an sku,
			// we dont want to get delivery promise for nothing,
			// or worse, for MOCKDATA!!!

			if ( !LC.helpers.isSku( sku ) ) {
				sku = _this.pdpdata.defaultsizesku;
			}

			LC.modal.ajax( url, {

				name: "delivery-date",
				skuid: sku,
				orderid: _this.pdpdata.orderId

			});

			LC.track.trigger( "ga.event", {
				category: "Delivery Promise",
				action: "Open Modal",
				label: "From PDP"
			});

		};

		ex.events = function() {

			_this.$deliveryDest
				.off("click.delivery")
				.on("click.delivery", function(e) {

					e.preventDefault();
					ex.openDeliveryModal();

				});

		};

		ex.subscribe = function() {

			/**
			 * whenever a color/size changes, we should
			 * trigger a delivery promise update.
			 */
			LC.pubsub.on(

				"pdp.chooseColor " +
				"pdp.chooseSize ",

				function( e, data ) {

					ex.getPromise( data.skuId );

				});

			/**
			 * listen for the deliveryPromise update
			 * and then refresh. This only handles the
			 * internal text/display of the details
			 */
			LC.pubsub.on( "deliveryPromise.update", function( e, data ) {

				// only refresh if the data "modalOnly"
				// is set to false. This is to allow updates
				// to the deliver promise which only affect the
				// modal dialog for delivery promise
				if ( !data.response.modalOnly ) {
					ex.refresh( data );
				}

			});

			/**
			 * listen for the pdp update
			 * and then set the state of the promise.
			 * This handles the show/hide of certain sections
			 */
			LC.pubsub.on( "pdp.update", function( e, data ) {

				_this.setWidgetState( data.response.atgResponse );
				_this.setCollectDisplay( data.response.atgResponse );
				_this.setDeliveryDisplay( data.response.atgResponse );

			});

			LC.pubsub.on( "pdp.initSizeSelect", function( e, data ) {

				/**
				 * see if the skuid exists, and then either hide
				 * the delivery promise if it doesnt, or get the
				 * promise if it does.
				 *
				 * The skuId might be empty if the page initialises
				 * with a product size which is out of stock, or
				 * "mockdata"
				 */

				if ( !LC.helpers.isSku( data.skuId ) ) {

					_this.canShow = false;
					_this.rebuild();

				} else {

					ex.getPromise( data.skuId );

				}

			});

		};

		return exports;

	}({}));

}( window.LC = window.LC || {}, jQuery ));


( function( LC, $ ) {

	"use strict";

	/**
	 *
	 * pdp.discovermore
	 * javascript for handling, or routing, for the "discover more" section
	 *
	 * @param  {Object} exports | public-access object of methods/properties
	 * @param  {Object} _this   | private-scoped object of methods/properties
	 * @return {Object}         | return the public-access object
	 */
	new lcmodule2( "pdp.discovermore", function( exports, _this ) {

		// "ex" is short-hand for exports (public access) object
		var ex = exports;

		/**
		 * setup() is executed when module is created
		 * but before the DOM is ready.
		 */
		ex.setup = function() {

		};

		/**
		 * init() is executed when DOM is ready.
		 */
		ex.init = function() {

		};

		/**
		 * events() is executed last, after the
		 * DOM is ready to receive event bindings.
		 */
		ex.events = function() {

		};

		/**
		 * subscribe() is executed after setup() and
		 * before the DOM is ready.
		 */
		ex.subscribe = function() {

		};

		return exports;

	});

}( window.LC = window.LC || {}, jQuery ));


( function( LC, $ ) {

	"use strict";

	/**
	 *
	 * pdp.promo.thumbs
	 * A littlem odule to enable thumbnails/images in the promo area
	 *
	 * @param  {Object} exports | public-access object of methods/properties
	 * @param  {Object} _this   | private-scoped object of methods/properties
	 * @return {Object}         | return the public-access object
	 */
	new lcmodule2( "pdp.promo.thumbs", function( exports, _this ) {

		// "ex" is short-hand for exports (public access) object
		var ex = exports;

		/**
		 * setup() is executed when module is created
		 * but before the DOM is ready.
		 */
		ex.setup = function() {



		};

		/**
		 * init() is executed when DOM is ready.
		 */
		ex.init = function() {

			_this.$promo = $( ".product-promo" );
			_this.$imgs = _this.$promo.first().find( "img" );
			_this.$thumbs = $( ".product-thumbnails" );

			if ( _this.$promo.length ) {
				ex.moveThumbs();
			}

		};

		ex.moveThumbs = function() {

			var $images = $( "<div class='product-promo-images' />" )
				.append( _this.$imgs );

			$images.insertAfter( _this.$thumbs );

			_this.$imgs.each(function() {

				var $img = $( this ),
					src = $img.attr("src"),
					isProduct = LC.helpers.isProductImage( src ),
					img = isProduct ? LC.format.productImage( src, "xl" ) : src,
					$bigImage = $("<img />").attr("src", img ).css({ height: "95vh" }),
					$content = $("<div class='product-promo-popup' />").append( $bigImage );

				$img.off("click").on("click", function() {
					LC.modal.open( $content );
				});

			});

		};

		return exports;

	});

}( window.LC = window.LC || {}, jQuery ));

/**
 *
 * [ module ]
 * pdp -> recentlyviewed
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.pdp = LC.pdp || {};

	LC.pdp.recentlyviewed = lcmodule( function( exports ) {

		exports.moduleName = "pdp.recentlyviewed";

		// "exports"" is always passed in, and always
		// returned at the end. Bind "ex" as it's easier to type
		// "_this" is used for private binding and maintaining scope

		var ex = exports = $.extend( {}, window.lcmoduledefaults, exports ),
			_this = {};

		/**
		 * initialise the recentlyviewed module
		 */
		ex.init = function() {

			_this.$container = $(".recently-viewed");

			ex.subscribe();

			// we wait some time to initialise the recent view section
			// as it's fairly heavy and better for performance to wait.
			setTimeout( function() {

				ex.refresh();
				LC.pubsub.trigger( "pdp.initRecentView" );

			}, 1000 );

		};

		/**
		 * replace the current discover section with the new one.
		 * and reinitialise the needed JS.
		 */
		ex.replaceContent = function( html ) {

			var $html = $(html),
				$contents = $html.children();

			// perform a nice animation to fade out
			// the recent view section.
			_this.$container.addClass("fade-in");
			requestAnimationFrame(function() {
				_this.$container.addClass("opc-0");
			});

			// only show the section again if it has results
			// to show, otherwise, let's just hide it.
			if ( _this.hasResults( $html ) ) {

				// use a timeout to wait for the previous
				// animation to finish.
				setTimeout(function() {

					// replace the contents, and perform
					// a nice animation to fade back in.
					_this.$container
						.html( $contents )
						.removeClass( "fade-in" )
						.removeClass( ex.hiddenClass )
						.addClass( "fade-out opc-0" );

					requestAnimationFrame(function() {
						_this.$container.removeClass("opc-0");
					});

					// re-activate the lazy-loading images
					LC.pubsub.trigger( "bindLazy", { scope: _this.$container });

				}, 300 );

			} else {

				_this.$container.addClass( ex.hiddenClass );

			}

		};

		/**
		 * when passed in the $container of the parent element
		 * in the recent view carousel, return whether there's
		 * any children items (products) returned.
		 * @param  {$object}  $container | the parent in the recent view section
		 * @return {Boolean}             | whether there's any products returned.
		 */
		_this.hasResults = function( $container ) {

			return (
				$container.length &&
				$container.find(".recently-viewed__carousel").html().trim() !== ""
			);

		};

		/**
		 * get the recently-viewed section of HTML from the
		 * server to append to document
		 */
		ex.getRecentlyViewed = function() {

			if ( typeof _this.ajax !== "undefined" ) {

				_this.ajax.abort();

			}

			_this.ajax = $.ajax({

				url: "/product/include/sections/recently-viewed.jsp",
				type: "POST",
				cache: false,
				data: {}

			})

				.done( function( response ) {

					ex.replaceContent( response );

				})

				.fail( function( xhr, status ) {

					LC.error( "recently viewed more ajax call failed: " + status );

				});

		};

		_this.rebuild = function() {

			ex.getRecentlyViewed();

		};

		ex.refresh = function() {

			_this.rebuild();

		};

		ex.events = function() {

		};

		ex.subscribe = function() {

			// whenever the pdp updates with new color / size sku
			// we should replace the recently viewed section if
			// the product is different!
			LC.pubsub.on( "pdp.update", function( e, data ) {

				if ( !data.not.includes("recentlyviewed") && data.isDifferent ) {

					ex.refresh();

				}

			});

		};

		return exports;

	}({}));

}( window.LC = window.LC || {}, jQuery ));

/**
 *
 * [ module ]
 * pdp -> sizeconversion
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.pdp = LC.pdp || {};

	LC.pdp.sizeconversion = lcmodule( function( exports ) {

		exports.moduleName = "pdp.sizeconversion";

		// "exports"" is always passed in, and always
		// returned at the end. Bind "ex" as it's easier to type
		// "_this" is used for private binding and maintaining scope

		var ex = exports = $.extend( {}, window.lcmoduledefaults, exports ),
			_this = {};

		ex.mobile = {};
		ex.tablet = {};

		_this.country = null;
		_this.selected = null;

		/**
		 * initialise the sizeconversion module
		 */

		ex.init = function() {

			_this.$conversion = 	$(".lc-conversion");
			_this.isMobile = 		$("body").data("mobile");

			// start checking if the fixture data
			// is available, we can't initialise without it.
			if ( _this.$conversion.length ) {

				_this.checkFixture();

			} else {

				LC.info( "📏 no client-side size conversion possible." );
				LC.pubsub.trigger( "pdp.showsizetype" );

			}

		};

		/**
		 * lazy init after the fixture has loaded,
		 * we do this to prevent the module loading
		 * before the data is ready. (data comes from an
		 * async javascript include in the size-conversion module)
		 */
		ex.lazyInit = function() {

			var isConvertable;

			_this.$labelSize = 		_this.$conversion.find(".lc-conversion__label-size");
			_this.$convertSize = 	_this.$conversion.find(".lc-conversion__convert-size");

			_this.$labelTab = 		_this.$labelSize.find(".lc-tabs__link");
			_this.$convertTab = 	_this.$convertSize.find(".lc-tabs__link");

			_this.$convertList = 		_this.$conversion.find(".lc-conversion__list");
			_this.$dropdown = 			_this.$convertSize.find(".lc-dropdown");
			_this.$dropdownDisplay = 	_this.$convertSize.find(".lc-dropdown__display");

			_this.$select =			$(".product-sizes__select");

			_this.defaultCountry =	_this.$conversion.data("country");
			_this.dimension = 		_this.$conversion.data("dimension");
			_this.gender = 			_this.$conversion.data("gender");


			// lets see if it's possible to convert
			isConvertable = _this.isConvertable( _this.defaultCountry );

			if ( isConvertable && _this.$conversion.length ) {

				// in case the container was hidden, show it.
				_this.$conversion.removeClass( ex.hiddenClass );

				// setup the dropdown on desktop
				if ( !_this.isMobile ) {
					_this.setupDropdown();
				}

				ex.populateCountryList();
				ex.showSavedCountry();

				ex.events();
				ex.subscribe();
				ex.displayWidget();

				if ( _this.isMobile ) {
					ex.mobile.events();
				} else {
					ex.tablet.events();
				}

			} else {

				// if we can't convert, then 🔥.
				ex.destroy();

			}

		};

		/**
		 * Method to display the widget when the page loads.
		 * This is to align with the color/size widgets.
		 */
		ex.displayWidget = function() {

			_this.$conversion.removeClass("opc-0");

		};

		/**
		 * decide whether to display the whole conversion wiget, or not.
		 * @param { object } response | atgResponse
		 */
		ex.setState = function( response ) {

			var sizes = response.atgResponse.sizeSwatchList,
				isStarSku,
				showSizeWidget,
				visible;

			// is the size widget shown? (we cant convert without sizes).
			showSizeWidget = LC.pdp.general.showSizeWidget( response );

			// is the product a star-sku? (we cant convert non-sizeset sizes).
			isStarSku = _.some( sizes, function( size ) {
				return LC.helpers.isStarSku( size.skuId );
			});

			// only visible when size widget shown, and not star sku.
			visible = showSizeWidget && !isStarSku;

			/**
			 * toggle the hidden class
			 */
			_this.$conversion
				.toggleClass( ex.hiddenClass, !visible );

		};

		/**
		 * method for determining if it is possible to
		 * convert the size of given country code.
		 *
		 * @param  {String}  country | country to determine if it's possible to convert
		 * @return {Boolean}         | can we convert the given country?
		 */
		_this.isConvertable = function( country ) {

			var convertable,
				defaultCountryInSizes,
				defaultCountryInCountries,
				defaultCountryMatch;

			convertable = false;

			if ( !country ) {
				return false;
			}

			// this is being wrapped with an error handler, because
			// we are not sure that the BCC fixtures will be correct,
			// or that the will always be present on the page.
			try {

				// when a dimension and gender exists,
				// we check the fixture, countries and sizes
				if ( _this.dimension && _this.gender ) {

					_this.fixture = 		LC.fixtures.sizeConversion;
					_this.countries = 		_this.fixture.countries;
					_this.sizes = 			_this.fixture.sizes[ _this.gender ][ _this.dimension ];

					// is the "defaultCountry" for the product, actually
					// existing in the JSON conversion country list?

					// we check the \" token in the REGEX to make
					// sure we're matching a complete value, and not a partial value.
					// 		eg: \"AU\" matches; "AU"
					// 		eg: \"AU\" does not match; "AUS"
					// 		eg: \"AU\" does not match; "AU & UK"
					defaultCountryMatch =
						new RegExp( "\"" + _this.defaultCountry + "\"" );

					defaultCountryInCountries =
						JSON.stringify( _this.countries ).match( defaultCountryMatch );

					defaultCountryInSizes =
						JSON.stringify( _this.sizes ).match( defaultCountryMatch );

					// when fixtures, countries and sizes are
					// available, we are able to convert!
					if ( _this.fixture && _this.countries && _this.sizes &&
					    defaultCountryInCountries && defaultCountryInSizes ) {

						convertable = true;

					} else if ( !defaultCountryInCountries ) {

						LC.warn(
							"the product's 'country' (" +
							_this.defaultCountry +
							") doesn't exist in the Country JSON."
						);

					} else if ( !defaultCountryInSizes ) {

						LC.warn(
							"the product's 'country' (" +
							_this.defaultCountry +
							") doesn't exist in the Size JSON."
						);

					}

				}

			} catch (e) {

				LC.warn( "unable to initialise Size Conversion due to data issue" );

			}

			return convertable;

		};

		/**
		 * based on the current product's gender and dimension,
		 * we return the list of countries (sorted alphabetically)
		 * from that size set. Used for populating the dropdown.
		 *
		 * @return { Array } | Array of country codes
		 */
		ex.getCountries = function() {

			var countries = [];

			_.each( _this.sizes, function( value, key ) {

				countries.push( key );

			});

			return countries.sort();

		};

		/**
		 * return the full country name for a given country code
		 *
		 * @param  { String } code | country code in the countries list
		 * @return { String }      | full country name
		 */
		ex.getCountryName = function( code ) {

			return _this.countries[ code ];

		};

		/**
		 * Populate list items in the dropdown
		 * with a list of countries that are applicable
		 * to the current product's gender/type.
		 *
		 * @return { $ } | list of countries
		 */
		ex.populateCountryList = function() {

			var countryList = ex.getCountries(),
				$list = $([]),
				listItemMobile = "<li class=\"lc-conversion__list-item / row pad-v2\" />",
				listItemTablet = "<li class=\"lc-dropdown__list-item lc-conversion__list-item\" />",
				$code = $("<span />"),
				$country = $("<span />"),
				$listItem;

			if ( _this.isMobile ) {

				// additional setup for the html on mobile
				$listItem = $( listItemMobile );
				$code.addClass("column txt-r mb-6 pad-0");
				$country.addClass("column txt-l mb-6 pad-0");

			} else {

				$listItem = $( listItemTablet );

			}

			/*
				we don't want to see "DEFAULT" as a country
				to convert to, it's only needed as a country to
				convert from! :)

				we also want to remove the label country, there's
				no point allowing users to convert
					US -> US
			 */
			_.pull( countryList, "DEFAULT", _this.defaultCountry );

			/*
				for each country returned, we will create
				a new dropdown list item to display, and add
				it to the collection.
			 */
			_.each( countryList, function( code ) {

				var country, $item, $itemCode, $itemCountry;
				country = ex.getCountryName( code );

				// do a bunch of formatting to display
				// the countries in a list format we really want.
				$itemCode = $code.clone().html( code + "&nbsp;- ");
				$itemCountry = $country.clone().html( "&nbsp;" + country );

				$item =
					$listItem
						.clone()
						.attr( "data-value", code )
						.html( $itemCode[ 0 ].outerHTML + $itemCountry[ 0 ].outerHTML );

				$list = $list.add( $item );

			});

			// update the list with the new items
			_this.$convertList.html( $list );

			if ( _this.isMobile ) {
				// bind event to handle the list items
				// being clicked!
				ex.mobile.events.listBind();
			}

			return $list;

		};

		/**
		 * method to manipulate the returned text
		 * from the dropdown component to be more desirable
		 *
		 *  - it should look like:
		 * 		"US - AMERICAN" -> "US"
		 *
		 * @param  { String } text  | string of text to manipulate, comes from dropdown
		 * @return { String }      	| manipulated string of text to show in display of dropdown
		 */
		_this.dropdownText = function( text ) {

			var regex = new RegExp( /\s-.*/gi );
			return text.replace( regex, "" );

		};

		/**
		 * method for setting up any customisation
		 * needed for the dropdown component
		 */
		_this.setupDropdown = function() {

			// we want to return the text as only "US" instead
			// of "US - American" so we use the "dropdownText()"
			// method to achieve this.
			var $dropdown = _this.$dropdown,
				dropdown;

			if ( $dropdown.length ) {
				dropdown = $dropdown.data("lcDropdown");
				dropdown.options.manipulateText = _this.dropdownText;
			}


		};

		/**
		 * Method for visually setting one of the tabs
		 * to be "active"
		 *
		 * @param  { String } which | "label" or "country" which represents which tab to select
		 */
		ex.selectTab = function( which ) {

			var $active,
				$inactive;

			if ( !which ) {
				LC.warn( "no 'which' paramter supplied for selecing a tab." );
			}

			switch ( which ) {

				case "label":

					$active = _this.$labelTab;
					$inactive = _this.$convertTab;
					// on mobile we want to deselect
					// the country in the list so the
					// UI doesn't look broken.
					ex.mobile.unselectCountry();

					break;

				case "country":

					$active = _this.$convertTab;
					$inactive = _this.$labelTab;

					break;

				default:

					break;

			}

			$active
				.addClass( "is-active" )
				.attr( "aria-selected", true );

			$inactive
				.removeClass( "is-active" )
				.removeAttr( "aria-selected" );

		};

		/**
		 * method for checking that the fixtues have loaded
		 * before trying to lazy-init the module. Without this
		 * data we cannot do anything.
		 */
		_this.checkFixture = function() {

			if (
				typeof LC.fixtures !== "undefined" &&
				typeof LC.fixtures.sizeConversion !== "undefined"
			) {

				ex.lazyInit();

			} else {

				// if the fixtures are not yet available,
				// we should wait a bit and try again.

				setTimeout(function() {

					_this.checkFixture();

				}, 100 );

			}

		};

		/**
		 * attempt to save the country we've
		 * selected in to the localstorage.
		 *
		 * @param  { String } country | Country Code
		 */
		_this.saveCountry = function( country ) {

			var savedCountry = _this.getSavedCountry();

			if ( country !== savedCountry ) {

				try {

					LC.localStorage.setItem( "conversionCountry", country );

				} catch (e) {

					LC.warn( "issue with localStorage" );
					LC.error( e );
					LC.info( "📏 flushing size-conversion data" );

					_this.unsaveCountry();

				}

			}

		};

		/**
		 * method to remove the saved local-storage country conversion
		 */
		_this.unsaveCountry = function() {

			LC.localStorage.removeItem( "conversionCountry" );

		};

		/**
		 * method to handle updating the UI
		 * to show the country that was saved in to
		 * the localstorage before.
		 */
		ex.showSavedCountry = function() {

			var defaultCountry = _this.defaultCountry,
				saved = _this.getSavedCountry(),
				$country;

			if ( saved && saved !== defaultCountry ) {

				$country =
					_this.$convertList
						.find( ".lc-conversion__list-item" )
						.filter( "[ data-value = '" + saved + "' ]" );

				if ( $country.length ) {

					if ( _this.isMobile ) {

						ex.mobile.selectCountry( saved );

					} else {

						ex.tablet.selectCountry( $country );

					}

					ex.selectTab( "country" );
					ex.convert( saved, { track: false } );

				}

			}

		};

		/**
		 * return the saved country from localstorage
		 * @return { String } | Country Code
		 */
		_this.getSavedCountry = function() {

			return LC.localStorage.getItem( "conversionCountry" );

		};

		/**
		 * Trigger the size conversion, but only if the
		 * currently selected country is different to the
		 * previously selected country
		 *
		 * @param  { String } country | the new country to convert to
		 * @param  { Object } options | an object with some options to use when converting
		 */
		ex.convert = function( country, options ) {

			/**
			 * options:
			 * 	- save: Boolean (true) - should we save the country?
			 * 	- track: Boolean (true) - should we save the country?
			 */

			var settings = $.extend({
				save: true,
				track: true
			}, options );

			if ( !_this.previousCountry || country !== _this.previousCountry ) {

				// if settings.save is passed as true,
				// then we will remove the saved country conversion
				// from the localStorage!
				if ( settings.save ) {

					_this.saveCountry( country );

				} else {

					_this.unsaveCountry();

				}

				if ( settings.track ) {

					// trigger trackConversion for tracking purpose.
					LC.pubsub.trigger( "pdp.trackConversion", { country: country });

				}

				// trigger convertSize with the country
				// as a param for usage in other modules (ie: size-picker).
				LC.pubsub.trigger( "pdp.convertSize", { country: country });

			}

			// update the previous country so we can
			// compare it next time around.
			_this.previousCountry = country;

		};

		ex.removeSizeConversion = function() {

			// hide/remove the conversion
			if ( _this.$conversion.length ) {

				_this.$conversion.addClass( ex.hiddenClass );
				_this.$conversion.remove();
				LC.info( "📏 size conversion disabled on this product" );

			}

		};

		/**
		 * destroy the size conversion and hide it
		 */
		ex.destroy = function() {

			ex.removeSizeConversion();
			LC.pubsub.trigger( "pdp.showsizetype" );
			// flush out the huge object for memory
			LC.pdp.sizeconversion = null;

		};

		/**
		 * refresh the user interface, with the new atg response
		 * @param  {object} data | atgResponse
		 */
		ex.refresh = function( data ) {

			var response = data.response;
			ex.setState( response );

		};

		/**
		 * events shared across both mobile/desktop
		 */
		ex.events = function() {

			/*
				whenever we click on the "label" tab (default)
				we want the conversion to go back to default
				display and de-select the dropdown list. Also to
				un-save the sizeConversion value in localStorage
			 */
			_this.$labelTab
				.off( ".sizeconversion" )
				.on( "click.sizeconversion", function(e) {

					e.preventDefault();

					// set the country to the original label country
					_this.selected = "label";
					_this.country = _this.$conversion.data( "country" );

					// select the correct tab, and convert
					ex.selectTab( _this.selected );
					ex.convert( _this.country, { save: false } );

					if ( !_this.isMobile ) {

						// reset the dropdown to original, and close
						_this.$dropdown.data().lcDropdown.close();
						_this.$dropdown.data().lcDropdown.setDefault();

					}

				});

		};

		/**
		 * select the country from the list in tablet view.
		 * @param  { $ } $country | item in list to select
		 */
		ex.tablet.selectCountry = function( $country ) {

			_this.$dropdown
				.data()
				.lcDropdown
				.selectItem( $country );

		};

		/**
		 * events specifically for tablet/desktop views
		 */
		ex.tablet.events = function() {

			_this.$dropdown
				.off( "select.dropdown" )
				.on( "select.dropdown", function( e, ui ) {

					_this.country = ui.$selected.data( "value" );

					// the "country" will be undefined if the user
					// just clicked the dropdown open, and the closed
					// it again without choosing an actual country.
					if ( typeof _this.country !== "undefined" ) {

						_this.selected = "country";
						ex.selectTab( _this.selected );
						ex.convert( _this.country );

					} else {

						_this.selected = "label";
						ex.selectTab( "label" );

					}

				});

		};

		/**
		 * open the sliding list on mobile devices
		 */
		ex.mobile.openList = function() {

			var windowTop = $(window).scrollTop(),
				listTop = _this.$conversion.dimensions().offset.top;

			ex.mobile.cancelClose();
			ex.mobile.listOpen = true;

			_this.$convertList.slideDown();
			_this.$dropdownDisplay.find(".lc-icon").addClass("go");

			/**
			 * some arbitrary numbers to decide if we need to
			 * help the user scroll the list in to view. This
			 * is based on if they are too close to the top, or
			 * close to the bottom of screen.
			 */
			if ( windowTop < ( listTop - 350 ) || windowTop > ( listTop - 100 ) ) {

				$("html, body")
					.animate({
						scrollTop: listTop - 100
					}, 300 );

			}

		};

		/**
		 * close the sliding list for mobile devices
		 * @param  { Integer } delay  	| a time (in ms) to wait before closing.
		 */
		ex.mobile.closeList = function( delay ) {

			delay = delay || 150;

			ex.mobile.cancelClose();

			// use a timer to close, as it's pretty annoying
			// if the list closes instantly, the users cannot
			// see feedback on what they've clicked if it closes instantly.
			_this.closeTimer = setTimeout( function() {

				ex.mobile.listOpen = false;
				_this.$convertList.slideUp();
				_this.$dropdownDisplay.find(".lc-icon").removeClass("go");

			}, delay );

		};

		/**
		 * Method to allow the closing time to be
		 * interrupted, this allows the user to continuously
		 * interact with the UI without the menu closing
		 * on them annoyingly.
		 */
		ex.mobile.cancelClose = function() {

			if ( _this.closeTimer ) {
				clearTimeout( _this.closeTimer );
				_this.closeTimer = null;
			}

		};

		/**
		 * toggle the sliding list
		 */
		ex.mobile.toggleList = function() {

			if ( !ex.mobile.listOpen ) {

				ex.mobile.openList();

			} else {

				ex.mobile.closeList();

			}

		};

		/**
		 * handle the UI update regarding
		 * un-selecting all countries. Just basically
		 * removes the css class on the list items.
		 */
		ex.mobile.unselectCountry = function() {

			var $selected =
				_this.$convertList
					.find(".lc-conversion__list-item")
					.filter(".is-selected");

			if ( $selected.length ) {
				$selected.removeClass("txt-bold is-selected");
			}

		};

		/**
		 * method for updaing the UI, and state, of
		 * the module, takign an argument of countrycode
		 * and doing what's needed to make the list look
		 * like the user has selected that country.
		 *
		 * @param  { String } countrycode | the countryCode user selected
		 */
		ex.mobile.selectCountry = function( countrycode ) {

			var $items,
				$selected,
				display;

			// first unselect any country previously selected
			ex.mobile.unselectCountry();

			// gather all the list items for countries
			$items =
				_this.$convertList
					.find(".lc-conversion__list-item");

			// filter the selected country by the countrycode
			// and apply the classes to indicate it is selected
			$selected =
				$items
					.filter("[ data-value = '" + countrycode + "' ]")
					.addClass("txt-bold is-selected");

			// do some manipulation on the country name for display
			display = _this.dropdownText( $selected.text() );

			// update the display section of the dropdown list
			_this.$dropdownDisplay
				.find(".lc-dropdown__display-text")
				.text( display );

			// close the list after a short delay,
			// this delay allows the user to click
			// multiple times in the list without losing
			// their mind due to it closing.
			ex.mobile.closeList( 600 );

		};

		/**
		 * events specifically for tmobile view
		 */
		ex.mobile.events = function() {

			_this.$dropdownDisplay
				.off( ".sizeconversion" )
				.on( "click.sizeconversion", function(e) {

					e.preventDefault();
					ex.mobile.toggleList();

				});

			// if the user starts interacting with the select, we cancel
			// the close action, this is to prevent the UI from
			// jumping around during interactions.
			_this.$select
				.off( ".sizeconversion" )
				.on( "click.sizeconversion touchstart.sizeconversion", function() {

					ex.mobile.cancelClose();

				});

		};

		/**
		 * method for binding "select" events to the dropdown
		 * list whenever it is populated, but this is
		 * only applicable for mobile devices, as the selection
		 * is handled on desktop by the dropdown API
		 */
		ex.mobile.events.listBind = function() {

			_this.$convertList
				.off( ".sizeconversion" )
				.on( "click.sizeconversion", ".lc-conversion__list-item", function(e) {

					var $item = $(this);

					e.preventDefault();
					_this.country = $item.data( "value" );

					// check there is an actual country selected
					if ( typeof _this.country !== "undefined" ) {

						_this.selected = "country";
						ex.selectTab( _this.selected );
						ex.mobile.selectCountry( _this.country );
						ex.convert( _this.country );

					} else {

						_this.selected = "label";
						ex.selectTab( "label" );

					}

				});

		};

		ex.subscribe = function() {

			LC.pubsub.on( "pdp.update", function( e, data ) {

				if ( !data.not.includes("size") ) {

					// refresh the conversion if the
					// pdp ui is updated.
					ex.refresh( data );

				}

			});

		};

		return exports;

	}({}));

}( window.LC = window.LC || {}, jQuery ));

/**
 *
 * [ module ]
 * pdp -> share
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.pdp = LC.pdp || {};

	LC.pdp.share = lcmodule( function( exports ) {

		exports.moduleName = "pdp.share";

		// "exports"" is always passed in, and always
		// returned at the end. Bind "ex" as it's easier to type
		// "_this" is used for private binding and maintaining scope

		var ex = exports = $.extend( {}, window.lcmoduledefaults, exports ),
			_this = {};

		ex.shareModal = "/common/social-share/share-qr-modal.jsp";

		/**
		 * initialise the share module
		 */

		ex.init = function() {

			// initialisation code

			_this.$sharing = $(".product-sharing");
			_this.$brand = $(".product-title__brand-name");
			_this.$name = $(".product-title__product-name");
			_this.$description = $(".product-description");
			_this.$canonical = $("link[ rel = canonical ]");
			_this.$socialButtons = _this.$sharing.find("[ data-provider ]");
			_this.$emailButton = $("#social-send-to-friend");

			_this.catLevel1 = $("meta[ name='product-subsection1']").attr("content");
			_this.catLevel2 = $("meta[ name='product-subsection2']").attr("content");

			_this.emailShown = _this.$emailButton.hasClass( ex.hiddenClass );

			ex.events();
			ex.subscribe();

		};

		_this.getId = function() {

			return $("#pdpdata").data("productId");

		};

		_this.getBu = function() {

			return $("#pdpdata").data("bu");

		};

		_this.getTitle = function() {

			var brand = _this.$brand.text().trim(),
				name = _this.$name.text().trim();

			return brand + " | " + name;

		};

		_this.getDescription = function() {

			var desc = _this.$description.text().trim();

			return desc;

		};

		_this.getSharingData = function( provider ) {

			return {

				provider: provider,
				title: _this.getTitle(),
				url: _this.getUrl( provider ),
				description: _this.getDescription(),
				thumbnail: _this.getThumbnail(),
				productId: _this.getId()

			};

		};

		_this.getUrl = function( provider ) {

			/* eslint quote-props: ["off"] */

			var url = new URI( _this.$canonical.attr("href") ),
				fragment = new URI().fragment(),
				capitalisedProvider = provider.charAt(0).toUpperCase() + provider.slice(1);

			return url
				.setQuery({
					"utm_medium": "social_media",
					"utm_content": "pdp_share",
					"utm_campaign": "pdp",
					"utm_source": capitalisedProvider
				})
				.fragment( fragment )
				.toString();

		};

		_this.getThumbnail = function() {

			// get DOM element here instead of in "init", because
			// the images can change when color/size changes.
			var activeImage =
				$(".hero-image")
					.filter(".is-selected")
					.data("res-xl");

			return LC.format.productImage( activeImage, "xl" );

		};

		/**
		 * Method to rearrange to massage data specifically
		 * for individual providers, this is because in GIGYA
		 * some providers show different data.
		 *
		 * @param  { Object } sharingData | The sharingData object from _this.getSharingData()
		 * @return { Object }           | The same object, massaged accordingly
		 *
		 */
		_this.massage = function( sharingData ) {

			switch ( sharingData.provider.toLowerCase() ) {

				case "facebook":

					sharingData.description = sharingData.title;
					break;

				case "sina":

					delete sharingData.thumbnail;	// Sina Weibo not support LC image
					break;

				case "whatsapp":
					sharingData.title = "";
					break;

				default:

					break;

			}

			return sharingData;

		};

		/**
		 * Method to hide the email to friend sharing button
		 */
		_this.hideEmail = function() {

			_this.$emailButton.addClass( ex.hiddenClass );
			_this.emailShown = false;

		};

		/**
		 * Method to show the email to friend sharign button
		 */
		_this.showEmail = function() {

			_this.$emailButton.removeClass( ex.hiddenClass );
			_this.emailShown = true;

		};

		/**
		 * Method to share the product with the given provider
		 * Provider should be all lowercase which maps to the
		 * Sharing provider list:
		 *
		 * @param  { String } provider | lowercase provider for gigya / analytics campaign
		 */
		ex.share = function( provider ) {

			var sharingData,
				isDesktop = 	Foundation.MediaQuery.atLeast("tb"),
				isWechat = 		LC.helpers.isWeChat(),
				qrLink;

			if ( !provider ) {

				LC.warn( "Social Sharing attempted without a provider" );
				return;

			}

			sharingData = _this.getSharingData( provider );
			sharingData = _this.massage( sharingData );

			LC.track.trigger("social", {

				network: sharingData.provider,
				action: "Share",
				path: sharingData.url

			});

			switch ( provider ) {

				/**
				 * on mobile we just want to open a mail
				 * client with a pre-set message, but on desktop
				 * we would like to use the "send-to-friend" modal
				 * form.
				 */
				case "email":

					ex.sendEmail();

					break;

				/**
				 * on desktop we show a QR code that the user can
				 * scan to share the current page, but on mobile
				 * we open the wechat app to share a "moment"
				 */
				case "wechat":

					qrLink = ( !isDesktop && !isWechat );
					ex.showQrModal( "wechat", qrLink );
					break;

				/**
				 * open a popup with the scannable QR code.
				 */
				case "qr":

					ex.showQrModal( "qr", false );
					break;

				/**
				 * default handling for provider using Gigya
				 */
				default:

					LC.pubsub.trigger( "social.share", {
						provider: provider,
						params: sharingData
					});

					break;

			}

		};

		/**
		 * Method to send the current product as an email
		 */
		ex.sendEmail = function() {

			var url = new URI().query({}).toString(),
				data = $(".product-title").data(),
				productName = encodeURIComponent( data.productName ),
				brandName = encodeURIComponent( data.brandName ),
				description = _this.$description.find("p").first().text(),
				subject = brandName + "%20%7C%20" + productName,
				lineBreakCharacter = "%0A%0A",
				body = "",
				final = "";

			// iOS app fail to render %0A%0A for line break optimization,
			// clear the special characters
			if (
				LC.helpers.isLcApp() ||
				LC.helpers.isWeChat()
			) {
				lineBreakCharacter = "";
			}

			if ( !LC.helpers.isLcApp() ) {
				url = encodeURIComponent( url );
				description = encodeURIComponent( description );
			}

			body = lineBreakCharacter + description + lineBreakCharacter + url;
			final = "mailto:?subject=" + subject + "&body=" + body;

			// go to the email link. We use location and not
			// window.open() because the window.open() doesn't
			// work on iPhones.
			LC.location.href = final;

		};

		/**
		 * Method to trigger a dialog-popup with a QR for scanning
		 *
		 * @param  { String } title   		| title of the QR Popup
		 * @param  { String } message 		| message at bottom of QR Popup
		 * @param  { Boolean } withShortUrl | should we also display a short URL link
		 */
		ex.showQrModal = function( provider, withShortUrl ) {

			var modalUrl = new URI( ex.shareModal ),
				productId = LC.pdp.general.getSelectedProductId();

			// add the parameters needed for generating
			// the QR code to the URI.
			modalUrl.setQuery({
				productId: productId,
				withLink: withShortUrl,
				provider: provider
			});

			// stringify the QR URL for ajax call
			modalUrl = modalUrl.toString();

			// close all modals and open a preloader.
			LC.modal.ajax( modalUrl, { name: "qr-code" })
				.modal
				.parent()
				.addClass("sharing-qr-code-modal / pad-20");

		};

		ex.events = function() {

			_this.$socialButtons
				.off(".pdpShare")
				.on("click.pdpShare", function(e) {

					e.preventDefault();
					var provider = $(this).data("provider");
					ex.share( provider );

				});

		};

		_this.refresh = function( data ) {

			var response = data.response.atgResponse,
				productStatus = response.availabilityWidgetInfo.productStatus,
				isSoldOut = productStatus.includes( "soldOut" ),
				isBackInStockSoon = productStatus.includes( "backInStockSoon" );

			/**
			 * Check if the product is sold out or not, and show the
			 * email button, this is because we can't send sold-out item
			 * to a friend as the email will possibly cause a server-error.
			 *
			 * Also check if the email button is already visible using a boolean,
			 * this is to help with performance, instead of checking the DOM for a class.
			 */
			if ( ( isSoldOut || isBackInStockSoon ) && _this.emailShown ) {

				_this.hideEmail();

			} else if ( !isSoldOut && !_this.emailShown ) {

				_this.showEmail();

			}

		};

		ex.subscribe = function() {

			LC.pubsub.on("pdp.sendToFriend", function() {
				ex.share( "email" );
			});

			LC.pubsub.on("pdp.share", function( e, data ) {
				ex.share( data.provider );
			});

			LC.pubsub.on("pdp.update", function( e, data ) {
				_this.refresh( data );
			});

		};

		return exports;

	}({}));

}( window.LC = window.LC || {}, jQuery ));


( function( LC, $ ) {

	"use strict";

	/**
	 *
	 * pdp.suggestions
	 * Short description of the module's purpose
	 *
	 * @param  {Object} exports | public-access object of methods/properties
	 * @param  {Object} _this   | private-scoped object of methods/properties
	 * @return {Object}         | return the public-access object
	 */
	new lcmodule2( "pdp.suggestions", function( exports, _this ) {

		// "ex" is short-hand for exports (public access) object
		var ex = exports;

		/**
		 * setup() is executed when module is created
		 * but before the DOM is ready.
		 */
		ex.setup = function() {

			_this.minimumProducts = 4;

			_this.config = LC.config.getValue( "recommendations" );
			_this.enabled = _this.config.enabled && _this.config.betalabs.enabled;

			_this.endpoints = {
				productList: "/common/partials/product-list.jsp",
				similarPlaceholder: "/product/include/sections/discover-more/similar.jsp"
			};

		};

		/**
		 * method to remove the "from=..." query string parameter
		 * from the URL of the page.
		 */
		ex.checkAndRemoveFromUrl = function() {

			if ( LC.queryparams.suggestionSource ) {
				history.replaceState( null, null,
					URI().removeQuery("suggestionSource").toString()
				);
			}

		};

		ex.getElements = function() {

			_this.$section = $( "#product-similar" );
			_this.$title = _this.$section.find( ".discover-more__title" );
			_this.$carousel = _this.$section.find( ".discover-more__carousel" );
			_this.$products = _this.$carousel.find( ".product-brick" );

		};

		/**
		 * init() is executed when DOM is ready.
		 */
		ex.init = function() {

			_this.from = LC.queryparams.from;
			_this.source = LC.queryparams.suggestionSource;
			_this.pdpdata = $("#pdpdata").data();
			_this.productId = _this.pdpdata.productId;

			if ( _this.enabled ) {

				$.when(
					LC.pdp.suggestions.waitfor( "pdp.suggestions.betalabs")
				).done(function() {

					// wait for the vendor modules to load before executing.
					ex.trackClickthrough();
					ex.checkAndRemoveFromUrl();

					ex.getElements();

					if ( _this.$section.length ) {

						_this.source = _this.$section.data( "source" );

						ex.fetchSimilarProducts()
							.done( function( productsChunk ) {
								LC.info( "Building similar items with: ", productsChunk );
								ex.buildCarousel( productsChunk );
							}).fail( function( err ) {
								_this.$section.empty();
								LC.warn( err );
							});

					}

				});

			}

		};

		ex.refresh = function( productId ) {

			var fetchOriginal = $.get( _this.endpoints.similarPlaceholder, {
				source: _this.source
			});

			fetchOriginal.done( function( result ) {

				_this.pdpdata.productId = productId;
				_this.$section.replaceWith( result );
				ex.init();

			});

		};

		/**
		 *
		 * @returns promise resolved with HTML chunk
		 */
		ex.fetchSimilarProducts = function() {

			var promise = new $.Deferred(),
				fetchResults,
				category = "PDP Similar Carousel",
				action = "api result from " + _this.source;

			switch ( _this.source ) {
				case "betalabs":
					fetchResults = _this.fetchResults.betalabs;
					break;
				// no default
			}

			if ( !fetchResults ) {
				promise.reject( "No valid Engine found for product carousel:",
					_this.source );
				return promise;
			}

			// first get products from Beta/Inteli
			fetchResults()
				.done( function( productIds ) {

					if ( productIds.length < _this.minimumProducts ) {

						promise.reject( "Not enough products returned from Engine:",
							_this.source, "(" + productIds + ")" );

						LC.track.trigger( "event", {
							category: category,
							action: action,
							label: _this.productId + " | not enough results; " + productIds.toString()
						});

					} else {

						// then get the HTML from ATG
						ex.fetchProductListChunk( productIds ).done( function( productsChunk ) {

							// if there's no products in stock; reject
							if ( productsChunk.trim() === "" ) {

								promise.reject( "Products from Engine out of stock:",
									_this.source, "(" + productIds + ")" );

								LC.track.trigger( "event", {
									category: category,
									action: action,
									label: _this.productId + " | results all out of stock"
								});

							} else {

								promise.resolve( productsChunk );

								LC.track.trigger( "event", {
									category: category,
									action: action,
									label: _this.productId + " | success with; " + productIds.toString()
								});

							}
						});

					}

				})
				.fail( function( error ) {

					promise.reject( "API call for products failed: ", _this.source, error );

					LC.track.trigger( "event", {
						category: category,
						action: action,
						label: _this.productId + " | api failed"
					});

				});

			return promise;

		};

		ex.fetchProductListChunk = function( productIds ) {

			if ( LC.helpers.getQueryParam( "overrideResult" ) ) {
				productIds = LC.helpers.getQueryParam( "overrideResult" ).split(",");
			}

			if ( !_.isArray( productIds ) ) {
				return new $.Deferred().reject( "" );
			}

			return $.get( _this.endpoints.productList, {
				productIds: productIds.join( "," ),
				isColumn: false,
				data: "type:similar",
				contentClass: "disp-ib va-t",
				urlParams: "?from=ProductSimilarCarousel&suggestionSource=" + _this.source
			});

		};

		// the fetchResults methods should return a promise
		// which resolves with a simple array of ATG ids
		_this.fetchResults = {};

		_this.fetchResults.betalabs = function() {

			// fetch, and homogenise the results
			var promise = new $.Deferred();

			LC.pdp.suggestions.betalabs.fetchRecommendations( _this.productId, _this.pdpdata.dept )
				.done( function( response )  {
					promise.resolve( _this.transformResults.betalabs( response ) );
				})
				.fail( function( error ) {
					promise.reject( error );
				});

			return promise;

		};

		_this.transformResults = {};

		_this.transformResults.betalabs = function( betaresponse ) {
			// betalabs response is a simple list of recommendations
			// and requires no re-mapping
			return betaresponse.recommendations;
		};


		ex.buildCarousel = function( productList ) {

			_this.$carousel.html( productList );
			ex.getElements();
			_this.$title.removeClass( "opc-0" );

			if ( Foundation.MediaQuery.atLeast( "tb" ) && _this.$products.length > 4 ) {

				_this.$carousel.flickity({

					adaptiveHeight: false,
					cellAlign: 		"left",
					contain: 		true,
					freeScroll: 	true,
					groupCells: 	true,
					pageDots: 		false

				});

			}

			// re-activate teh lazy-loading for carousel
			LC.pubsub.trigger( "bindLazy", { scope: _this.$container });

		};

		ex.trackClickthrough = function() {

			if ( _this.enabled && _this.from && _this.source ) {

				LC.pubsub.trigger( "pdp.suggestion.track", {
					from: _this.from,
					source: _this.source,
					type: "clickthrough",
					productId: _this.productId
				});

			}

		};

		ex.trackAddToCart = function( data ) {

			var productId = data.productId,
				quantity = data.quantity;

			if ( _this.enabled ) {

				LC.pubsub.trigger( "pdp.suggestion.track", {
					from: _this.from,
					source: _this.source,
					type: "cart",
					productId: productId,
					quantity: quantity
				});

			}

		};

		ex.trackAddToWishlist = function( data ) {

			var productId = LC.helpers.productFromSku( data.skuId );

			if ( _this.enabled ) {

				LC.pubsub.trigger( "pdp.suggestion.track", {
					from: _this.from,
					source: _this.source,
					type: "wishlist",
					productId: productId
				});

			}

		};

		/**
		 * events() is executed last, after the
		 * DOM is ready to receive event bindings.
		 */
		ex.events = function() {



		};

		/**
		 * subscribe() is executed after setup() and
		 * before the DOM is ready.
		 */
		ex.subscribe = function() {

			LC.pubsub
				.off( "pdp.addProduct.suggestions" )
				.on( "pdp.addProduct.suggestions", function( e, data ) {
					ex.trackAddToCart( data );
				});

			LC.pubsub
				.off( "wishlist.itemAdded.suggestions" )
				.on( "wishlist.itemAdded.suggestions", function( e, data ) {
					ex.trackAddToWishlist( data );
				});

			// whenever the pdp updates with new color / size sku
			// we should replace the discover section
			LC.pubsub
				.off( "pdp.update.suggestions" )
				.on( "pdp.update.suggestions", function( e, data ) {

					if ( !data.not.includes( "discovermore" ) && data.isDifferent ) {

						var productId = data.response.atgResponse.essentialInfo.productId;
						ex.refresh( productId );

					}

				});


		};

		return exports;

	});

}( window.LC = window.LC || {}, jQuery ));

/**
 *
 * [ module ]
 * pdp -> swatchPicker
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.pdp = LC.pdp || {};

	LC.pdp.swatchPicker = lcmodule( function( exports ) {

		exports.moduleName = "pdp.swatchPicker";

		// "exports"" is always passed in, and always
		// returned at the end. Bind "ex" as it's easier to type
		// "_this" is used for private binding and maintaining scope

		var ex = exports = $.extend( {}, exports ),
			_this = {};

		_this.$modalContainer = $("<div class=\"txt-c\" />");

		/**
		 * initialise the swatchPicker module
		 */

		ex.init = function() {

			// initialisation code

			_this.imageClasses = "pos-a t-0 l-0 mb-12 / blur-load";
			_this.imageSize = "m";

			ex.events();
			ex.subscribe();

		};

		ex.lazyInit = function( data ) {

			_this.$dialog = $(".swatch-picker-dialog");
			_this.$titleSize = _this.$dialog.find(".swatch-picker-dialog__title--size");
			_this.$titleColor = _this.$dialog.find(".swatch-picker-dialog__title--color");
			_this.$preview = _this.$dialog.find(".swatch-picker-dialog__img-holder");
			_this.$chipContainer = _this.$dialog.find(".swatch-picker-dialog__chips");
			_this.$chipsTitle = _this.$dialog.find(".swatch-picker-dialog__color-title");
			_this.$button = _this.$dialog.find(".swatch-picker-dialog__update-button");

			// these are the original page widgets
			_this.$colors = $(".product-colors__list");
			_this.$colorsTitle = $(".product-colors__title");
			_this.$sizes = $(".product-sizes__list");

			_this.leftKey = 37;
			_this.upKey = 38;
			_this.rightKey = 39;
			_this.downKey = 40;
			_this.enterKey = 13;
			_this.spaceKey = 32;

			// sort out the UI during init
			ex.displayTitle( data.type );
			ex.displayPreview( data.type );
			ex.displayChips( data.type );
			ex.focusSelected();

			// bind events after UI updated
			ex.lazyEvents( data.type );

		};

		/**
		 * method for dispalying the correct
		 * title at the top of the modal
		 *
		 * @param  { String } type 	| "color" or "size"
		 * @return { $Object }      | the title element
		 */
		ex.displayTitle = function( type ) {

			var $title;

			switch ( type ) {

				case "size":

					$title = _this.$titleSize;
					break;

				case "color":

					$title = _this.$titleColor;
					break;

				default:
					break;

			}

			return $title.removeClass("hide");

		};

		/**
		 * initialise and display the product image
		 * when the modal initialises (only on tablet)
		 */
		ex.displayPreview = function() {

			if ( Foundation.MediaQuery.atLeast("tb") ) {

				var $img = $("<img />"),
					src = $(".hero-image .hero-image__img").first().attr("src"),
					image = LC.format.productImage( src, "xs" );

				$img
					.attr( "src", image )
					.addClass( _this.imageClasses )
					.attr( "data-lazy", LC.format.productImage( src, _this.imageSize ) );

				_this.$preview.html( $img );

				$img.lazy({ instant: true });

			}

		};

		/**
		 * update the product image with a new
		 * image based on a supplied ID (only on tablet)
		 *
		 * @param  { String } id | product id
		 */
		ex.updatePreview = function( id ) {

			if ( Foundation.MediaQuery.atLeast("tb") ) {

				var $img = $("<img />"),
					image = LC.helpers.imageFromId( id, "xs" ),

					// find out the current image state
					$currentImage = _this.$preview.find("img"),
					currentId = LC.helpers.idFromImage( $currentImage.attr("src") );

				// only need to replace/update the preview image
				// if it is different, based on product ID.
				if ( currentId !== id ) {

					$currentImage.remove();

					$img
						.attr( "src", image )
						.addClass( _this.imageClasses )
						.attr( "data-lazy", LC.helpers.imageFromId( id, _this.imageSize ) );

					_this.$preview.html( $img );

					$img.lazy({ instant: true });

				}

			}

		};

		/**
		 * create the need html elements for the
		 * ui to represent the colour picker.
		 *
		 * @param  { String } type 	| "color" or "size"
		 * @return { $object }      | the swatch container
		 */
		ex.createChips = function( type ) {

			var $swatch;

			switch ( type ) {

				case "size":

					$swatch = _this.$sizes.clone();
					break;

				case "color":

					$swatch = _this.$colors.clone();
					break;

				default:
					break;

			}

			return $swatch;

		};

		/**
		 * display the chips in the UI, after
		 * they've been created
		 *
		 * @param  { String } type | "color" or "size"
		 */
		ex.displayChips = function( type ) {

			// first get a HTML string of chips
			// to display.
			var $chips = ex.createChips( type );

			// next, append them to the container,
			// and then stack them properly.
			_this.$chipContainer
				.html( $chips )
				.lcStackSwatches();

			// then update the color title.
			if ( type === "color" ) {
				ex.updateColorName( $chips.find("input[type=radio]:checked") );
			}

		};

		/**
		 * method to focus the selected chip for
		 * keyboard navigation.
		 */
		ex.focusSelected = function() {

			_this.$chipContainer
				.find( "input[type=radio]:checked" )
				.trigger( "focus" );

		};

		/**
		 * method for opening the swatch picker
		 * interface and supplying the type of picker.
		 *
		 * @param  { String } type 	| "size" or "color"
		 */
		ex.openSwatchPicker = function( type ) {

			var url = "/dialog/_revamp/pdp/swatch-picker.jsp";

			_this.modal = LC.modal.load( url, {
				name: "swatch-picker-" + type,
				type: type
			});

		};

		/**
		 * method for updating the swatch UI after the
		 * user selected a $chip
		 *
		 * @param  { $Object } $chip | the chip that was selected
		 */
		ex.updateSwatch = function( $chip ) {

			if ( $chip.length ) {

				var data = $chip.data(),
					$item = $chip.parent(),
					$items = $item.parent().siblings().children();

				$item.addClass("lc-label--active");
				$items.removeClass("lc-label--active");

				ex.updatePreview( data.id );
				ex.updateColorName( $chip );

			}

		};

		/**
		 * using the name of the selected chip, we
		 * want to update the title with that color name
		 *
		 * @param  { $Object } $chip | The selected chip we want to use as the color title
		 */
		ex.updateColorName = function( $chip ) {

			var $title = _this.$chipsTitle,
				data = $chip.data();

			if ( data.displayname ) {

				$title.text( data.displayname );
				$title.removeClass( "disp-n" );

			}

		};

		/**
		 * method for confirming the selected
		 * swatch chip, and firing the pdp update method
		 * which will refresh teh entire PDP with the
		 * selected item
		 *
		 * @param  { String } type | "color" or "size"
		 */
		ex.chooseSwatch = function( type ) {

			var $radio = _this.$chipContainer.find( "input[type=radio]:checked" ),
				data = $radio.data(),
				original,
				module;

			switch ( type ) {

				case "size":

					original = _this.$sizes.find( "input[type=radio]:checked" ).data();
					module = LC.pdp.sizepicker;
					break;

				case "color":

					original = _this.$colors.find( "input[type=radio]:checked" ).data();
					module = LC.pdp.colorpicker;
					break;

				default:
					break;

			}

			// only run the chip select method if we selected
			// a size/colour different from the original!
			if ( typeof original === "undefined" ||
			     ( typeof original.skuid !== "undefined" &&
			       data.skuid !== original.skuid )) {

				// module is a reference to the pdp module
				// for size/color picker
				module.change( data.id, data.skuid, true );

			}

		};

		/**
		 * method for handling key-presses on the
		 * modal dialog.
		 * - ENTER/SPACE should close it.
		 * - UP/DOWN should jump 5 spaces.
		 *
		 * @param  { String } type 	| "color" or "size"
		 * @param  { Event }  e 	| jQuery event object
		 */
		ex.handleKeyup = function( type, e ) {

			var $inputs = _this.$chipContainer.find("input[type=radio]"),
				$selected = $inputs.filter(":checked"),
				selectedIndex = $inputs.index( $selected ),
				jumpValue = 0,
				jumpDirection,
				newIndex;

			// figure out which key was pressed
			switch ( e.which ) {

				// if we pressed "space" or "enter", then we
				// want to select the current color and update
				// the UI, then close the dialog.
				case _this.spaceKey:
				case _this.enterKey:

					e.preventDefault();
					ex.chooseSwatch( type );

					_this.modal.modal.dialog("close");

					break;

				// if pressed "left", we want to go back
				// one color.
				case _this.leftKey:

					jumpValue = 1;
					jumpDirection = "backward";

					break;

				case _this.upKey:

					jumpValue = 5;
					jumpDirection = "backward";

					break;

				case _this.rightKey:

					jumpValue = 1;
					jumpDirection = "forward";

					break;

				case _this.downKey:

					jumpValue = 5;
					jumpDirection = "forward";

					break;

				default:
					break;

			}

			if ( jumpValue ) {

				e.preventDefault();

				if ( jumpDirection === "forward" ) {

					newIndex = selectedIndex + jumpValue;

				} else {

					newIndex = selectedIndex - jumpValue;

				}

				if ( newIndex < 0 ) {

					newIndex = $inputs.length - 1;

				} else if ( newIndex > ( $inputs.length - 1 ) ) {

					newIndex = 0;

				}

				$inputs
					.eq( newIndex )
					.prop( "checked", true )
					.trigger( "change.swatchPicker" );

			}

			return e;

		};

		/**
		 * capture the keydown event for up/down arrows
		 * and prevent the action from interfering with
		 * our keyup event.
		 *
		 * @param  { Event } e | jQuery event object
		 */
		ex.handleKeydown = function( e ) {

			switch ( e.which ) {

				case _this.leftKey:
				case _this.upKey:
				case _this.rightKey:
				case _this.downKey:

					e.preventDefault();
					break;

				default:
					break;

			}

			return e;

		};

		ex.events = function() {

			// events bound at page load
			// before the modal opens

		};

		/**
		 * events to be bound at time of modal loading
		 *
		 * @param  { String } type | "color" or "size"
		 */
		ex.lazyEvents = function( type ) {

			// this can be color or size
			var $chips = _this.$chipContainer.find("input[type=radio]");

			// when we change the color/size, we
			// want to update the UI
			$chips
				.off(".swatchPicker")
				.on("change.swatchPicker", function(e) {
					ex.updateSwatch( $( e.target ) );
				});

			// when the dialog update button
			// is triggered, we want to refresh
			// the main PDP page with the selected
			// color / size
			_this.$button
				.off(".swatchPicker")
				.on( "click.swatchPicker", function() {
					ex.chooseSwatch( type );
				});

			// when the dialog update button
			// is triggered, we want to refresh
			// the main PDP page with the selected
			// color / size
			_this.$chipContainer
				.off(".swatchPicker")
				.on( "keydown.swatchPicker", ex.handleKeydown )
				.on( "keyup.swatchPicker", function( e ) {
					ex.handleKeyup( type, e );
				});

		};

		ex.subscribe = function() {

			// use pubsub for triggering the swatch
			// picker opening.
			LC.pubsub
				.off("pdp.openSwatchPicker")
				.on("pdp.openSwatchPicker", function( e, data ) {

					if ( typeof data !== "undefined" && data.type ) {

						ex.openSwatchPicker( data.type );

					}

				});

			// initialise the swatch picker module when
			// the modal dialog opens
			LC.pubsub.on("global.initModal", function( e, data ) {
				if ( data.name.includes("swatch-picker") ) {
					ex.lazyInit( data );
				}
			});

		};

		return exports;

	}({}));

}( window.LC = window.LC || {}, jQuery ));


( function( LC, $ ) {

	"use strict";

	/**
	 *
	 * pdp.suggestions.betalabs
	 * Module for handling betalabs suggestions / tracking
	 *
	 * @param  {Object} exports | public-access object of methods/properties
	 * @param  {Object} _this   | private-scoped object of methods/properties
	 * @return {Object}         | return the public-access object
	 */
	new lcmodule2( "pdp.suggestions.betalabs", function( exports, _this ) {

		// "ex" is short-hand for exports (public access) object
		var ex = exports;

		/**
		 * setup() is executed when module is created
		 * but before the DOM is ready.
		 */
		ex.setup = function() {

			var referrerProduct = document.referrer.match(/\b([A-Z]{3}[0-9]{3})\/product.lc\b/);
			_this.referralCode = _.isArray(referrerProduct) ? referrerProduct[ 1 ] : "";

			if ( LC.helpers.isChinaSite() ) {
				_this.region = "CN";
			} else if ( LC.helpers.isHongKongSite() ) {
				_this.region = "HK";
			} else {
				_this.region = "ROW";
			}

		};

		/**
		 * init() is executed when DOM is ready.
		 */
		ex.init = function() {

			_this.pdpdata = $("#pdpdata").data();
			_this.productId = _this.pdpdata.productId;
			_this.visitorid = LC.betalabs.getVisitorId();

			ex.trackPageView();

		};

		ex.fetchRecommendations = function( productId, dept ) {

			var overrideProduct = LC.helpers.getQueryParam( "overrideProduct" ),
				visitorId = overrideProduct ? "TEST" : LC.config.getValue("profile.vipNumber"),
				settings;


			if ( overrideProduct ) {
				productId = overrideProduct;
			}

			settings = {
				async: true,
				crossDomain: true,
				url: LC.betalabs.getEndpoint(),
				method: "GET",
				data: {
					productCode: productId,
					userId: visitorId,
					region: _this.region
				}
			};

			return $.ajax( settings );

		};

		ex.modifyFromData = function( from ) {

			if ( from === "ProductSimilarCarousel" ) {
				return "similar";
			}

			return "";

		};

		ex.track = function( data ) {

			switch ( data.type ) {

				case "clickthrough":
					if ( data.source === "betalabs" ) {
						ex.trackClickthrough( data );
					}
					break;

				case "cart":
					ex.trackCart( data );
					break;

				case "wishlist":
					ex.trackWishlist( data );
					break;

				// no default

			}

		};

		ex.trackPageView = function() {

			/* eslint-disable camelcase */
			LC.betalabs.tracker.page({
				vip_no: _this.visitorid,
				atg_code: _this.productId
			});
			/* eslint-enable camelcase */

		};

		ex.trackClickthrough = function( data ) {

			var from = ex.modifyFromData( data.from );

			/* eslint-disable camelcase */
			LC.betalabs.tracker.track( "click_through", {
				vip_no: _this.visitorid,
				atg_code: data.productId,
				referred_atg_code: _this.referralCode,
				referral_type: from || ""
			});
			/* eslint-enable camelcase */

		};

		ex.trackCart = function( data ) {

			var from = ex.modifyFromData( data.from );

			/* eslint-disable camelcase */
			LC.betalabs.tracker.track( "add_to_cart", {
				vip_no: _this.visitorid,
				atg_code: data.productId,
				referred_atg_code: _this.referralCode,
				referral_type: from || "",
				quantity: data.quantity,
				price: parseFloat( $("meta[itemprop=price]").attr("content") )
			});
			/* eslint-enable camelcase */

		};

		ex.trackWishlist = function( data ) {

			var from = ex.modifyFromData( data.from );

			/* eslint-disable camelcase */
			LC.betalabs.tracker.track( "add_to_wish_list", {
				vip_no: _this.visitorid,
				atg_code: data.productId,
				referred_atg_code: _this.referralCode,
				referral_type: from || ""
			});
			/* eslint-enable camelcase */

		};

		/**
		 * events() is executed last, after the
		 * DOM is ready to receive event bindings.
		 */
		ex.events = function() {

		};

		/**
		 * subscribe() is executed after setup() and
		 * before the DOM is ready.
		 */
		ex.subscribe = function() {

			// handle tracking for the events, send the data
			// back to the vendor so they can track the purchase
			// flow of user, and impressions on suggestions.

			LC.pubsub
				.off( "pdp.suggestion.track.betalabs" )
				.on( "pdp.suggestion.track.betalabs", function( e, data ) {

					// betalabs are creating engines based on clicks / adds, and not
					// reporting conversions, and because of this they want to track
					// all click-through, and all add-to-cart, and all add-to-wishlist
					// events no matter if it's from inteli/beta/none.

					// So we need to fire tracking for all sources.

					ex.track( data );

				});

			LC.pubsub
				.off("pdp.addToCart.betalabs")
				.on("pdp.addToCart.betalabs", function( e, data ) {

					ex.trackCart({
						from: LC.queryparams.from,
						productId: data.productId,
						quantity: data.quantity
					});

				});

			LC.pubsub
				.off("pdp.trackClickAddWishlist.betalabs")
				.on("pdp.trackClickAddWishlist.betalabs", function( e, data ) {

					ex.trackWishlist({
						from: LC.queryparams.from,
						productId: data.productId
					});

				});

		};

		return exports;

	});

}( window.LC = window.LC || {}, jQuery ));


/**
 *
 * [ module ]
 * pdp -> modal -> addtobag
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.pdp = LC.pdp || {};
	LC.pdp.modal = LC.pdp.modal || {};

	LC.pdp.modal.addtobag = lcmodule( function( exports ) {

		exports.moduleName = "pdp.modal.addtobag";

		// "exports" is always passed in, and always
		// returned at the end. Bind "ex" as it's easier to type
		// "_this" is used for private binding and maintaining scope

		var ex = exports = $.extend( {}, window.lcmoduledefaults, exports ),
			_this = {};



		/**
		 * initialise the add to bag module
		 */
		ex.init = function() {

			ex.subscribe();

		};

		ex.lazyInit = function() {

			_this.$modal = $(".add-to-bag-dialog");
			_this.$checkoutForm = $("#globalMoveToCheckoutForm");
			_this.$checkoutBtn = _this.$modal.find(".add-to-bag-dialog__checkout-button");
			_this.$continueBtn = _this.$modal.find(".add-to-bag-dialog__continue-button");

			ex.events();

		};

		_this.checkout = function() {

			_this.$checkoutForm.trigger("submit");
			LC.pubsub.trigger("preloader.open");

		};

		ex.events = function() {

			_this.$checkoutBtn
				.off(".addtobag")
				.on("click.addtobag", _this.checkout );

		};

		ex.subscribe = function() {

			LC.pubsub.on( "global.initModal", function( e, data ) {
				if ( data.name === "add-to-bag" ) {
					ex.lazyInit();
				}
			});

		};

		return exports;

	}({}));

}( window.LC = window.LC || {}, jQuery ));


/**
 *
 * [ module ]
 * pdp -> modal -> preorder
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.pdp = LC.pdp || {};
	LC.pdp.modal = LC.pdp.modal || {};

	LC.pdp.modal.preorder = lcmodule( function( exports ) {

		exports.moduleName = "pdp.modal.preorder";

		// "exports" is always passed in, and always
		// returned at the end. Bind "ex" as it's easier to type
		// "_this" is used for private binding and maintaining scope

		var ex = exports = $.extend( {}, window.lcmoduledefaults, exports ),
			_this = {};



		/**
		 * initialise the pr-order module
		 */
		ex.init = function() {

			ex.subscribe();

		};

		ex.lazyInit = function() {

			_this.$preOrderForm = $("#pdpGenuinePreOrderContentContainer");
			_this.successUrl = $("#preorder-successurl").val();

			_this.$modal = $(".pre-order-dialog");
			_this.$errorHolder = $(".pre-order-dialog__errors");
			_this.$errorTemplate = $(".pre-order-error__other");
			_this.$commitBtn = _this.$modal.find(".pre-order-dialog__commit-button");

			ex.events();

		};

		_this.commit = function() {

			ex.removeErrors();

			if ( _this.ajax ) {
				_this.ajax.abort();
			}

			LC.pubsub.trigger("preloader.open");

			_this.ajax = $.ajax({

				url: _this.$preOrderForm.attr("action"),
				type: "POST",
				data: _this.$preOrderForm.serialize(),
				dataType: "json"

			})

				.done( _this.commitSuccess )

				.always( function() {

					LC.pubsub.trigger("preloader.close");

				});

		};

		ex.removeErrors = function() {

			_this.$errorHolder
				.find("[ class *= 'pre-order-error__' ]")
				.addClass( ex.hiddenClass )
				.filter(".is-cloned")
				.remove();

		};

		_this.commitSuccess = function( response ) {

			var success = response && (response.isProcessSuccess);

			if ( success ) {

				ex.successModal();

			} else {

				_.each( response.errorList, function( item ) {

					var $error = _this.$errorTemplate.clone();

					$error
						.text( item.errorMessage )
						.removeClass( ex.hiddenClass )
						.addClass( "is-cloned" )
						.appendTo( _this.$errorHolder );

				});

			}

		};

		ex.successModal = function() {

			var url = _this.successUrl;

			LC.modal.closeAll();
			LC.modal.ajax( url );

		};

		ex.events = function() {

			_this.$commitBtn
				.off(".preorder")
				.on("click.preorder", _this.commit );

		};

		ex.subscribe = function() {

			LC.pubsub.on( "global.initModal", function( e, data ) {
				if ( data.name === "pre-order" ) {
					ex.lazyInit();
				}
			});

		};

		return exports;

	}({}));

}( window.LC = window.LC || {}, jQuery ));


/**
 *
 * [ module ]
 * pdp -> modal -> sendtofriendsuccess
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.pdp = LC.pdp || {};
	LC.pdp.modal = LC.pdp.modal || {};

	LC.pdp.modal.sendtofriendsuccess = lcmodule( function( exports ) {

		exports.moduleName = "pdp.modal.sendtofriendsuccess";

		// "exports" is always passed in, and always
		// returned at the end. Bind "ex" as it's easier to type
		// "_this" is used for private binding and maintaining scope

		var ex = exports = $.extend( {}, window.lcmoduledefaults, exports ),
			_this = {};



		/**
		 * initialise the coming-soon module
		 */
		ex.init = function() {

			ex.subscribe();

		};

		ex.lazyInit = function() {

			_this.$modal = $(".send-to-friend-success-dialog");
			_this.$sendAnotherBtn = _this.$modal.find(".send-to-friend-success__another-button");

			ex.events();

		};

		_this.sendAnother = function() {

			LC.modal.closeAll();
			LC.pubsub.trigger("pdp.sendToFriend");

		};

		ex.events = function() {

			_this.$sendAnotherBtn
				.off(".sendtofriendsuccess")
				.on("click.sendtofriendsuccess", _this.sendAnother );

		};

		ex.subscribe = function() {

			LC.pubsub.on( "global.initModal", function( e, data ) {
				if ( data.name === "send-to-friend-success" ) {
					ex.lazyInit();
				}
			});

		};

		return exports;

	}({}));

}( window.LC = window.LC || {}, jQuery ));


/**
 *
 * [ module ]
 * pdp -> modal -> sendtofriend
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.pdp = LC.pdp || {};
	LC.pdp.modal = LC.pdp.modal || {};

	LC.pdp.modal.sendtofriend = lcmodule( function( exports ) {

		exports.moduleName = "pdp.modal.sendtofriend";

		// "exports" is always passed in, and always
		// returned at the end. Bind "ex" as it's easier to type
		// "_this" is used for private binding and maintaining scope

		var ex = exports = $.extend( {}, window.lcmoduledefaults, exports ),
			_this = {};



		/**
		 * initialise the coming-soon module
		 */
		ex.init = function() {

			ex.subscribe();

		};

		ex.lazyInit = function() {

			_this.$sendFriendForm = $("#sendEmailFriendForm");
			_this.postUrl = _this.$sendFriendForm.attr("action");
			_this.successUrl = "/dialog/_revamp/pdp/send-to-friend/success.jsp";

			_this.$modal = $(".send-to-friend-dialog");
			_this.$messageDetails = _this.$modal.find(".send-to-friend-dialog__message-details");
			_this.$sendBtn = _this.$modal.find(".send-to-friend-dialog__submit-button");

			_this.$sender = $("#sendToFrdSender");
			_this.$senderFirst = $("#sendToFrdSenderFirstName");
			_this.$senderLast = $("#sendToFrdSenderLastName");

			_this.$recipient = $("#sendToFrdRecipient");
			_this.$recipientFirst = $("#friendFirstName");
			_this.$recipientLast = $("#friendLastName");

			_this.$productName = $("#productType");
			_this.$message = $("#sendToFrdMessage");
			_this.$copyCheckbox = $("#sendEmailCopy");

			ex.events();

		};

		_this.sendACopy = function() {

			var sender = _this.$sender.val(),
				recipient = _this.$recipient.val();

			if ( _this.$copyCheckbox.prop("checked") ) {

				$("#sendToFrdFormFriend").val( recipient + "," + sender );

			}

		};

		_this.populateForm = function() {

			$("#sendToFrdFormSender").val( _this.$sender.val() );
			$("#sendToFrdFormSenderFirstName").val( _this.$senderFirst.val() );
			$("#sendToFrdFormSenderLastName").val( _this.$senderLast.val() );

			$("#sendToFrdFormFriend").val( _this.$recipient.val() );
			$("#sendToFrdFormFriendFirstName").val( _this.$recipientFirst.val() );
			$("#sendToFrdFormFriendLastName").val( _this.$recipientLast.val() );

			$("#sendToFrdFormProductType").val( _this.$productName.val() );
			$("#sendToFrdFormMessage").val( _this.$message.val() );

			_this.sendACopy();

		};

		_this.submit = function() {

			LC.pubsub.trigger("preloader.open");

			_this.populateForm();

			_this.ajax = $.ajax({

				url: _this.postUrl,
				type: "POST",
				data: _this.$sendFriendForm.serialize(),
				dataType: "json"

			})

				.done( _this.submitSuccess )

				.always( function() {

					LC.pubsub.trigger("preloader.close");

				});

		};

		_this.submitSuccess = function( response ) {

			var success = response && (response.isProcessSuccess);

			if ( success ) {

				_this.successModal();

			} else {

				LC.pubsub.trigger("forms.showErrors", {
					form: ".send-to-friend-dialog__form",
					response: response
				});

			}

		};

		_this.successModal = function() {

			var success = new URI( _this.successUrl );

			success.setQuery({
				skuId: 			_this.$messageDetails.data("sku-id"),
				productId: 		_this.$messageDetails.data("product-id"),
				recipientEmail: _this.$recipient.val()
			});

			LC.modal.closeAll();

			LC.modal.ajax( success.toString(), {
				name: "send-to-friend-success"
			});

		};

		ex.events = function() {

			_this.$sendBtn
				.off(".sendtofriend")
				.on("click.sendtofriend", _this.submit );

		};

		ex.subscribe = function() {

			LC.pubsub.on( "global.initModal", function( e, data ) {
				if ( data.name === "send-to-friend" ) {
					ex.lazyInit();
				}
			});

		};

		return exports;

	}({}));

}( window.LC = window.LC || {}, jQuery ));

 //# sourceURL=pdp.lazy.js
